import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ClickableTile, Tag } from '@carbon/react';
import { Plug } from '@carbon/react/icons';
import { useZaloIntegration } from 'src/hooks/useIntegrations';

const Integrations = React.memo(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { data: zalo } = useZaloIntegration();

  // The detail routes render through the Outlet; only the root path shows the catalog.
  const isRoot = location.pathname === '/settings/integrations' || location.pathname === '/settings/integrations/';

  return (
    <div className="store-settings-page">
      <div className="store-settings-page__main-content">
        {isRoot ? (
          <ClickableTile onClick={() => navigate('/settings/integrations/zalo')} renderIcon={Plug}>
            <h3>{t('integrations.zalo.name')}</h3>
            <p>{t('integrations.zalo.summary')}</p>
            <Tag type={zalo?.enabled ? 'green' : 'gray'}>
              {zalo?.enabled ? t('integrations.status.enabled') : t('integrations.status.disabled')}
            </Tag>
          </ClickableTile>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
});

export default Integrations;
